import { InjectionKey } from 'vue'

export interface MeiliSearchConfig {
  url: string
  apiKey: string
}

export const MEILI_SEARCH_CONFIG_KEY: InjectionKey<MeiliSearchConfig> =
  Symbol('meiliSearchConfig')
